module.exports = __webpack_public_path__ + "img/my-type-5.86fc6486.png";